module.exports = __webpack_public_path__ + "static/media/besties-en.0c56d0eb.png";